import { Card, Col, Row, Statistic, Tooltip } from 'antd'

import { formatUsdHourly } from '../format'
import { STATS_WINDOW_HOURS, useGpuStats } from '../hooks/useGpuAdmin'

export function StatsCard({ provider }: { provider: string }) {
  const { data, error, isLoading } = useGpuStats(provider)

  return (
    <Card
      size="small"
      title={`Last ${STATS_WINDOW_HOURS} hours`}
      loading={isLoading}
    >
      {error && error.message}
      {data && (
        <Row gutter={[16, 16]}>
          <Col flex="1 0 120px">
            <Statistic title="Creations" value={data.creations} />
          </Col>
          <Col flex="1 0 120px">
            <Statistic title="Activated" value={data.successful} />
          </Col>
          <Col flex="1 0 120px">
            <Statistic
              title="Reservation refused"
              value={data.reservation_refused}
            />
          </Col>
          <Col flex="1 0 120px">
            <Statistic title="Provider failed" value={data.provider_failed} />
          </Col>
          <Col flex="1 0 120px">
            <Statistic title="Live leases now" value={data.live_leases} />
          </Col>
          <Col flex="1 0 120px">
            <Statistic
              title="Burn now"
              value={formatUsdHourly(data.usd_per_hour)}
            />
          </Col>
          <Col flex="1 0 120px">
            <Tooltip title="Counted only in worker metrics, not exposed here">
              <Statistic title="Orphans" value={data.orphans ?? '—'} />
            </Tooltip>
          </Col>
        </Row>
      )}
    </Card>
  )
}
